module.exports = __webpack_public_path__ + "img/index_intro_sm05.9e3c0e77.jpg";